import { render } from "./PillNavigation.vue?vue&type=template&id=34d8ee38&scoped=true"
import script from "./PillNavigation.vue?vue&type=script&lang=js"
export * from "./PillNavigation.vue?vue&type=script&lang=js"

import "./PillNavigation.vue?vue&type=style&index=0&id=34d8ee38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8ee38"]])

export default __exports__